import React from 'react';
import { Toast } from 'react-bootstrap';
import PropTypes from 'prop-types';

const STATUS_STYLES = {
    error: { backgroundColor: '#dc3545', color: '#fff' },
    success: { backgroundColor: '#28a745', color: '#fff' },
    warning: { backgroundColor: '#ffc107', color: '#212529' },
    info: { backgroundColor: '#17a2b8', color: '#fff' },
    default: { backgroundColor: '#343a40', color: '#fff' },
};

const POSITION_STYLES = {
    'top-start': { top: '1rem', left: '1rem' },
    'top-end': { top: '1rem', right: '1rem' },
    'bottom-start': { bottom: '1rem', left: '1rem' },
    'bottom-end': { bottom: '1rem', right: '1rem' },
};

const CustomToast = ({
    show,
    onClose,
    title,
    bodyText,
    status = 'default',
    delay = 3000,
    autohide = true,
    position = 'top-end',
}) => {
    const statusStyles = STATUS_STYLES[status] || STATUS_STYLES.default;
    const positionStyles = POSITION_STYLES[position] || POSITION_STYLES['top-end'];

    return (
        <div
            aria-live="polite"
            aria-atomic="true"
            style={{
                position: 'fixed',
                zIndex: 9999,
                ...positionStyles,
            }}
        >
            <Toast
                onClose={onClose}
                show={show}
                delay={delay}
                autohide={autohide}
                style={{
                    minWidth: '250px',
                    ...statusStyles,
                }}
            >
                {title && <Toast.Header closeButton={true} style={{ backgroundColor: 'transparent', borderBottom: 'none' }}>
                    <strong className="me-auto" style={{ color: statusStyles.color }}>
                        {title}
                    </strong>
                </Toast.Header>}
                {bodyText && <Toast.Body style={{ color: statusStyles.color }}>{bodyText}</Toast.Body>}
            </Toast>
        </div>
    );
};

CustomToast.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    bodyText: PropTypes.string,
    status: PropTypes.oneOf(['default', 'error', 'success', 'warning', 'info']),
    delay: PropTypes.number,
    autohide: PropTypes.bool,
    position: PropTypes.oneOf(['top-start', 'top-end', 'bottom-start', 'bottom-end']),
};

export default CustomToast;
